import { produce } from 'immer';
import { Dispatch, SetStateAction, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useMount from '../../../../../../common/hooks/useMount';
import Dialog from '../../../../../../common/widgets/Dialog';
import PdfViewer from '../../../../../../common/widgets/PdfViewer';
import { resources } from '../../../../resources/resources';
import { FinalReportState } from '../FinalReportState';

interface IDownloadReportsDialogProps {
  setDialog: Dispatch<SetStateAction<FinalReportState>>;
  file: File;
}

export default function DownloadReportDialog(
  props: Readonly<IDownloadReportsDialogProps>,
) {
  const { setDialog, file } = props;
  const { t: translate } = useTranslation();
  const [base64String, setBase64String] = useState<string>('');

  const fileToBase64 = (file: File): Promise<string> => {
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result?.toString() ?? '');
      reader.onerror = error => reject(error);
    });
  };

  useMount(() => {
    fileToBase64(file).then(res => setBase64String(res));
  });

  const handleDownloadFile = () => {
    const href = URL.createObjectURL(file);

    const link = document.createElement('a');
    link.href = href;
    link.setAttribute('download', `${file.name}.pdf`);
    link.click();

    URL.revokeObjectURL(href);
  };

  return (
    <Dialog
      closeDialog={() =>
        setDialog(
          produce(draft => {
            draft.showDownloadDialog = false;
          }),
        )
      }
      showCloseIcon
      className="dialog-100% download-report-dialog"
    >
      <div className="dialog-content">
        <div className="dialog-text centered">
          <PdfViewer data={base64String} />
        </div>
      </div>

      <div className="dialog-actions horizontal">
        <button className="btn btn-solid" onClick={handleDownloadFile}>
          {translate(resources.admin.finalReport.grid.actions.download)}
        </button>
        <button
          onClick={() =>
            setDialog(
              produce(draft => {
                draft.showDownloadDialog = false;
              }),
            )
          }
          className="btn btn-outline"
        >
          {translate(resources.back)}
        </button>
      </div>
    </Dialog>
  );
}
